<template>
  <div>
    <div style="background: #F7F5F2;padding: 16px 10px 60px 10px;">
      <van-tabs type="none" v-model="menuName" style="padding-top: 16px;">
        <van-tab name="Channels">
          <template #title>
            <div class="custom-title">
              {{ $t('home_tabChannels') }}
              <span v-if="$store.state.hasUnreadChannelMsg" class="unread-dot"></span>
            </div>
          </template>
        </van-tab>
        <van-tab name="Matches">
          <template #title>
            <div class="custom-title">
              {{ $t('tab_connections') }}
              <span v-if="unreadMatchBadge" class="unread-badge">{{ unreadMatchBadge }}</span>
              <span v-else-if="$store.state.hasUnreadMatch" class="unread-dot"></span>
            </div>
          </template>
        </van-tab>
        <van-tab name="Messages">
          <template #title>
            <div class="custom-title">
              {{ $t('tab_conversations') }}
              <span v-if="unreadMsgBadge" class="unread-badge">{{ unreadMsgBadge }}</span>
              <span v-else-if="$store.state.hasUnreadMsg" class="unread-dot"></span>
            </div>
          </template>
        </van-tab>
        <van-tab name="Profile">
          <template #title>
            <div class="custom-title">{{ $t('tab_profile') }}</div>
          </template>
        </van-tab>
      </van-tabs>
      <component :is="curCom" ref="currentComponent"></component>
    </div>

    <!-- History Popup Dialog (Chat Sessions only) -->
    <van-popup v-model="showHistoryChats" position="bottom" round :style="{ height: '85%', width: '100%' }">
      <HistoryPage ref="historyPage" @close="showHistoryChats = false" />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { areaList } from '@vant/area-data';
import { Dialog, Toast, Col, Row, Search, Button, Popup, Grid, GridItem, Tab, Tabs, RadioGroup, Radio, Badge, Icon, Popover } from 'vant'
Vue.use(Col)
Vue.use(Row)
Vue.use(Button)
Vue.use(Popup)
Vue.use(Grid)
Vue.use(GridItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Badge)
Vue.use(Icon)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Popover)
Vue.use(Search)

import AiMatch from './AiMatch'
import HistoryPage from './HistoryPage'
import Connections from './Connections'
import Contacts from './Contacts'
import PersonalCenter from './PersonalCenter'
import Channels from './Channels'

export default {
  name: 'My',
  components: {
    'AiMatch': AiMatch,
    'HistoryPage': HistoryPage,
    'Matches': Connections,
    'Conversations': Contacts,
    'Messages': Contacts,
    'Profile': PersonalCenter,
    'Channels': Channels
  },
  props: {
    msg: String
  },
  data() {
    return {
      curCom: '',
      myTabName: this.$route.query.myTabName,
      openGroupChat: this.$route.query.openGroupChat,
      menuName: '',
      showHistoryChats: false,
      discoverRefreshing: false,
      discoverLoading: false,
    }
  },
  computed: {
    beforeEatchInitialized() {
      return this.$store.state.beforeEatchInitialized
    },
    // matches tab 未读数（99+ 封顶；为 0 时退回红点，旧后端兼容）
    unreadMatchBadge() {
      const count = parseInt(this.$store.state.unreadMatchCount, 10) || 0
      if (count > 99) return '99+'
      return count > 0 ? String(count) : ''
    },
    // messages tab 总未读数 = 私聊未读会话数 + 未读互动通知条数（与 App 端一致，为 0 时退回红点）
    unreadMsgBadge() {
      const chat = parseInt(this.$store.state.unreadChatCount, 10) || 0
      const inter = parseInt(this.$store.state.unreadInteractionCount, 10) || 0
      const total = chat + inter
      if (total > 99) return '99+'
      return total > 0 ? String(total) : ''
    }
  },
  mounted() {
    this.$store.state.floatBtn.show = false
    if (this.myTabName) {
      if (this.myTabName === 'Connections' || this.myTabName === 'Conversations') {
        this.menuName = 'Messages'
      } else if (this.myTabName === 'AiMatch' || this.myTabName === 'Discover') {
        this.menuName = 'Channels'
      } else {
        this.menuName = this.myTabName
      }
    }
  },
  watch: {
    menuName: {
      handler(newValue, oldValue) {
        this.curCom = ""
        let vm = this
        setTimeout(function () {
          vm.curCom = newValue
          // 切换到 Matches 页时刷新数据
          if (newValue === 'Matches') {
            const matchesComponent = vm.$refs.currentComponent
            if (matchesComponent && matchesComponent.refresh) {
              matchesComponent.refresh()
            }
          }
        }, 200)
      }
    },
    beforeEatchInitialized(newValue) {
      // 未读检查已迁移到 App.vue，此处不再需要
    }
  },
  methods: {
    // 未读检查和 WS 监听已迁移到 App.vue
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.qrcode-float {
  right: 20px;
  z-index: 1000;
  top: 85%;
  writing-mode: vertical-lr;
  background: #34A853;
  color: white;
  padding: 10px 6px;
  border-radius: 10px;
  position: fixed;
  font-size: 0.75rem;
}

.small-btn .van-button {
  height: 24px;
}

.small-btn .van-button--normal {
  font-size: 0.75rem;
}

.active {
  border: 2px solid #E8543A;
}

.custom-title-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.custom-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.unread-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #E05252;
  margin-left: 4px;
}

.unread-badge {
  display: inline-block;
  min-width: 16px;
  height: 16px;
  line-height: 16px;
  padding: 0 4px;
  border-radius: 9px;
  background-color: #E05252;
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
  box-sizing: border-box;
}

.title-icons {
  display: flex;
  align-items: center;
  gap: 8px;
}

</style>

<style scoped>
/* Tab 样式（仅限本页：此块必须 scoped，全局 .van-tab 会污染登录弹窗等其他 van-tabs） */
.van-tab {
  border: 1px solid #E0DDD8;
}

.van-tab--active {
  background: #eee;
  padding: 20px 0px;
  border-bottom: none;
}
</style>


// WEBPACK FOOTER //
// src/components/FrontPage.vue